module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"recordInProgress":"Recording in progress","notifyAboutRecord":"Don\u0027t forget to notify the candidate before starting the recording."}}')
  delete Component.options._Ctor
}
